/* COSYFUR Atelier — interactions */
(function () {
  'use strict';

  /* Offre de bienvenue : le compte à rebours 24 h démarre à la toute première visite du site */
  try {
    if (!localStorage.getItem('cosyfur_bienvenue_t0')) {
      localStorage.setItem('cosyfur_bienvenue_t0', String(Date.now()));
    }
  } catch (e) {}

  /* Header : transparent → solide au scroll */
  var header = document.getElementById('siteHeader');
  if (header) {
    var onScroll = function () {
      header.classList.toggle('is-solid', window.scrollY > 40);
    };
    window.addEventListener('scroll', onScroll, { passive: true });
    onScroll();
  }

  /* Menu mobile */
  var burger = document.getElementById('burger');
  var mobileMenu = document.getElementById('mobileMenu');
  if (burger && mobileMenu) {
    burger.addEventListener('click', function () {
      var open = mobileMenu.classList.toggle('is-open');
      burger.setAttribute('aria-expanded', open ? 'true' : 'false');
    });
  }

  /* Reveal on scroll */
  if ('IntersectionObserver' in window) {
    var io = new IntersectionObserver(function (entries) {
      entries.forEach(function (e) {
        if (e.isIntersecting) {
          e.target.classList.add('is-visible');
          io.unobserve(e.target);
        }
      });
    }, { threshold: 0.12, rootMargin: '0px 0px -40px 0px' });
    document.querySelectorAll('.reveal').forEach(function (el) { io.observe(el); });
  } else {
    document.querySelectorAll('.reveal').forEach(function (el) { el.classList.add('is-visible'); });
  }

  /* Galerie produit : vignettes */
  var mainImg = document.getElementById('galleryMain');
  if (mainImg) {
    document.querySelectorAll('.gallery-thumbs button').forEach(function (btn) {
      btn.addEventListener('click', function () {
        mainImg.src = btn.getAttribute('data-src');
        document.querySelectorAll('.gallery-thumbs button').forEach(function (b) {
          b.classList.toggle('is-active', b === btn);
        });
      });
    });
  }

  /* Variantes : swatch → sélectionne le coloris (pour le panier), met à jour le nom affiché, la photo principale
     ET la disponibilité (badge, offres, bouton d'achat, alerte retour en stock) */
  var variantInput = document.getElementById('variantId');
  if (variantInput) {
    var appliquerColoris = function (radio) {
      variantInput.value = radio.value;
      var nom = radio.getAttribute('data-nom');
      if (nom) document.querySelectorAll('#finitionNom, [data-finition-nom]').forEach(function (el) { el.textContent = nom; });
      var dispo = radio.getAttribute('data-dispo') !== 'false';
      document.querySelectorAll('[data-si-dispo]').forEach(function (el) { el.hidden = !dispo; });
      document.querySelectorAll('[data-si-rupture]').forEach(function (el) {
        el.hidden = dispo && !el.hasAttribute('data-poste');
      });
      var tags = document.getElementById('alerteTags');
      var coloris = radio.getAttribute('data-coloris');
      if (tags && coloris) tags.value = tags.getAttribute('data-base') + ',coloris-' + coloris;
    };
    /* Le navigateur peut restaurer un autre coloris coché (retour arrière) : on se recale dessus */
    var coche = document.querySelector('.swatch input:checked');
    if (coche) appliquerColoris(coche);
    document.querySelectorAll('.swatch input').forEach(function (radio) {
      radio.addEventListener('change', function () {
        appliquerColoris(radio);
        var nom = radio.getAttribute('data-nom');
        var image = radio.getAttribute('data-image');
        if (image && mainImg) {
          mainImg.src = image;
          if (nom) mainImg.alt = nom;
          document.querySelectorAll('.gallery-thumbs button').forEach(function (b) {
            b.classList.toggle('is-active', b.getAttribute('data-src') === image);
          });
        }
        if (history.replaceState) {
          var url = new URL(window.location.href);
          url.searchParams.set('variant', radio.value);
          history.replaceState(null, '', url.toString());
        }
      });
    });
  }

  /* Quantité +/- */
  document.querySelectorAll('.qty').forEach(function (q) {
    var input = q.querySelector('input');
    var btns = q.querySelectorAll('button');
    if (!input || btns.length < 2) return;
    btns[0].addEventListener('click', function () {
      input.value = Math.max(1, (parseInt(input.value, 10) || 1) - 1);
    });
    btns[1].addEventListener('click', function () {
      input.value = (parseInt(input.value, 10) || 1) + 1;
    });
  });
})();
